import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";

import { useIntl } from "react-intl";
import { connect } from "react-redux";

import Card from "../../UI/Card/Card";
import ErrorPanel from "../../UI/ErrorPanel/ErrorPanel";

import Button from "../../UI/Button/Button";
import CheckBox from "../../UI/Button/CheckboxButton";

import { faCheck } from "@fortawesome/free-solid-svg-icons";

import * as ChannelActions from "../../../middleware/Store/Actions/ChannelActions";

import LogService from "../../../middleware/CommonSdk/LogService";
const LOG_TAG = "SETTINGS-OPTIONS";

const Options = (props) => {

    const intl = useIntl();

    const [isSubscribed, setIsSubscribed] = useState(props.isChannelSubscribed);
    const [progress, setProgress] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    LogService.trace(LOG_TAG, "isSubscribed:", isSubscribed);
   
    useEffect(() => {
        setProgress(props.progress);
    }, [props.progress]);

    useEffect(() => {
        setErrorMessage(props.error.errorMessage);
    }, [props.error]);

    const handleSubmit = (e) => {
        LogService.trace(LOG_TAG, "handleSubmit");

        let callback = function () {
            LogService.trace(LOG_TAG, "handleSubmit", "Update subscribed succefully and refresh value...");
        };

        if (isSubscribed === true) {
            props.subscribeChannel(callback, this);

        } else {
            props.unSubscribeChannel(callback, this);
        }
    }

    let disableSubmitBtn = props.progress;

    return (
        <Card id="option-card" title={intl.messages.otherOption}>
            
                <div className="form-group">
                    <CheckBox 
                        id="option-checkbox"
                        checked={isSubscribed}
                        label={intl.messages.optionsSubscribe + " " +  props.channel.name}
                        onClick={e => setIsSubscribed(!isSubscribed)}
                    />
                </div>

                <div className="panel bg-fog mb-3">{intl.messages.optionsSubscribeMessage}</div>
                
                <Button
                    id="option-submit"
                    className="btn-submit"
                    label={intl.messages.apply}
                    icon={faCheck}
                    onClick={handleSubmit}
                    spinner={progress}
                    disabled={disableSubmitBtn}
                />

                {(errorMessage) &&
                    <div className="col-10 float-right">
                        <ErrorPanel id="option-error">{errorMessage}</ErrorPanel>
                    </div>
                }
        </Card>
    );
}

Options.propTypes = {
    channel: PropTypes.object,
    error: PropTypes.object,
    progress: PropTypes.bool,
    isChannelSubscribed: PropTypes.bool
}

const mapStateToProps = state => {
    return {
        error: state.channel.error,
        progress: state.channel.isInProgress,
        channel: state.channel.data,
        isChannelSubscribed: state.channel.data.subscribed
    };
};

const mapDispatchToProps = dispatch => {
    return {
        subscribeChannel:(callback, context) => dispatch(ChannelActions.subscribeChannel(callback, context)),
        unSubscribeChannel:(callback, context) => dispatch(ChannelActions.unSubscribeChannel(callback, context)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Options);